import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'users-icon',
  templateUrl: './users-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UsersIconComponent {}
